import {Component} from 'react';
import apiService from '../lib/apiService';

export default class AppDownloadRedirect extends Component {
  componentWillMount() {
    let bike_uuid = this.props.params.bike_uuid
    apiService(`/bicycles/${bike_uuid}/`, 'GET', {fields: 'app_download_url'})
    .then(this.handleErrors)
    .then((response) => response.json())
    .then((json) => {
      // if no app_download_url then redirect to the default Noa Rider page
      window.location = json.app_download_url || window.location.origin
    })
  }

  // Always redirects prior to render
  render() {
    return null;
  }

  // If we don't get a 200 back it's either a private fleet, an invalid bike_uuid, or the bike is not available
  // Redirect to the default Noa Rider page
  handleErrors(response) {
    if (!response.ok) {
      window.location = window.location.origin;
    }
    return response;
  }
}


// WEBPACK FOOTER //
// ./src/views/AppDownloadRedirect.js